import React from 'react';

/**
 * Bandera de las tablas. Sin marcar solo lleva contorno; marcada va rellena
 * con el color de acento del tema (`currentColor`), de modo que la diferencia
 * no depende solo del color.
 */
export const FlagIcon = ({ filled }: { filled: boolean }): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5 21V4" />
    <path d="M5 4h12l-2.5 4L17 12H5" />
  </svg>
);
